<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><router-link tag="a" to="/">Inicio</router-link></li>
                <li>Exámenes</li>
            </ul>
        </div>
    </div>
    

    <div class="bg_color_1 ">
        <div class="container margin_120_95">
            <div class="main_title">
                <h1>Exámenes</h1>
            </div>

            <div class="row ">
                <div class="col-12">
                   <ExamsList/>
                </div>
            </div>
        </div>
    </div>
    

    <Footer></Footer>

</div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import ExamsList from '@/views/ExamsList'

export default {
	name: 'Examns',
	metaInfo: {
		title: 'Exámenes',
	},
	components: {
		Navigation,
		Footer,
		ExamsList,
	},
}
</script>

<style scoped>
.label {
	font-weight: 500;
}
.link {
	color: #3d3d3d;
	margin-left: 8px;
}
li {
	margin-bottom: 16px;
}
ul {
	-moz-column-count: 2;
	-moz-column-gap: 20px;
	-webkit-column-count: 2;
	-webkit-column-gap: 20px;
	column-count: 2;
	column-gap: 20px;
}

@media (max-width: 767px) {
	ul {
		-moz-column-count: 1;
		-moz-column-gap: 20px;
		-webkit-column-count: 1;
		-webkit-column-gap: 20px;
		column-count: 1;
		column-gap: 20px;
	}
}
</style>
